import { render, staticRenderFns } from "./unreadNotificationsCount.vue?vue&type=template&id=586a5613"
import script from "./unreadNotificationsCount.vue?vue&type=script&lang=js"
export * from "./unreadNotificationsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports